import React from 'react';

export const Payment = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1178_5005)">
                <path
                    d="M11.6665 1.83073C11.1276 1.72073 10.5721 1.66517 9.99984 1.66406C5.39734 1.66406 1.6665 5.3949 1.6665 9.9974C1.6665 14.5999 5.39734 18.3307 9.99984 18.3307C14.6023 18.3307 18.3332 14.5999 18.3332 9.9974C18.3321 9.42517 18.2765 8.86962 18.1665 8.33073"
                    stroke="#67ABFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.99967 7.4988C9.07884 7.4988 8.33301 8.0588 8.33301 8.7488C8.33301 9.4388 9.07884 9.9988 9.99967 9.9988C10.9205 9.9988 11.6663 10.5588 11.6663 11.2488C11.6663 11.9388 10.9205 12.4988 9.99967 12.4988M9.99967 7.4988C10.7247 7.4988 11.343 7.8463 11.5713 8.33214M9.99967 7.4988V6.66547M9.99967 12.4988C9.27467 12.4988 8.65634 12.1513 8.42801 11.6655M9.99967 12.4988V13.3321M14.1647 5.8338L17.6447 2.35214M18.3313 5.3988L18.233 2.8238C18.233 2.2163 17.8705 1.83797 17.2097 1.79047L14.6063 1.66797"
                    stroke="#67ABFF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1178_5005">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
